// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.censored_projection_enum */
var CensoredProjectionEnum;
(function (CensoredProjectionEnum) {
    CensoredProjectionEnum["NULL_VALUE"] = "NULL_VALUE";
    CensoredProjectionEnum["ZERO"] = "ZERO";
    CensoredProjectionEnum["LIMIT"] = "LIMIT";
})(CensoredProjectionEnum || (CensoredProjectionEnum = {}));
;
export default CensoredProjectionEnum;
/** Zod schema for censored_projection_enum */
export const censoredProjectionEnum = z.nativeEnum(CensoredProjectionEnum);
//# sourceMappingURL=CensoredProjectionEnum.js.map